import PropTypes from 'prop-types';
import React from 'react';
import { Record } from 'immutable';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';

import ValidatedField from '../form/ValidatedField';
import ShowPassword from '../form/ShowPassword';
import PasswordHints from './PasswordHints';

class CustomerPassword extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        form: PropTypes.instanceOf(Record).isRequired,
        field: PropTypes.string,
        hideOptional: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        validation: PropTypes.object,
        placeholder: PropTypes.string,
        label: PropTypes.string,
        visited: PropTypes.bool,
        required: PropTypes.bool,
        onBlur: PropTypes.func,
        outsideLabel: PropTypes.bool,
        onFocus: PropTypes.func,
        showPasswordIcon: PropTypes.bool,
        showPasswordHints: PropTypes.bool,
        autoComplete: PropTypes.string,
    };

    static defaultProps = {
        id: 'password',
        validation: null,
        visited: false,
        required: true,
        placeholder: '',
        label: '',
        onFocus: _.noop,
        onBlur: _.noop,
        outsideLabel: false,
        showPasswordIcon: false,
        showPasswordHints: false,
        autoComplete: null,
    };

    state = {
        isPasswordShown: false
    };

    togglePasswordShown = e => {
        e.preventDefault();
        e.stopPropagation();
        this.setState(state => ({ isPasswordShown: !state.isPasswordShown }));
    };

    render() {
        const {
            id,
            form,
            field,
            label,
            placeholder,
            validation,
            visited,
            onChange,
            onFocus,
            onBlur,
            outsideLabel,
            required,
            showPasswordIcon,
            showPasswordHints,
            autoComplete,
            hideOptional
        } = this.props;
        const { isPasswordShown } = this.state;

        const passwordLabel = label || t('customerdetails.password');
        const ariaDescribedById = `desc-${field}`;
        const passwordError = _.get(validation, 'field') || form.getError(field);

        return (
            <div className="create-password password-field">
                <ValidatedField
                    field={field}
                    form={form}
                    id={id}
                    data-test-id="customer-password-input"
                    isPasswordShown={isPasswordShown}
                    label={passwordLabel}
                    labelClassName="sr-only"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onChange={onChange}
                    placeholder={placeholder || passwordLabel}
                    autoComplete={autoComplete}
                    required={required}
                    indicator={
                        showPasswordIcon ? (
                            <ShowPassword
                                active={isPasswordShown}
                                onClick={this.togglePasswordShown}
                            />
                        ) : null
                    }
                    type={isPasswordShown ? 'text' : 'password'}
                    validation={validation}
                    visited={visited}
                    errorClassName={showPasswordHints ? 'alert-danger' : null}
                    hideOptional={hideOptional}
                    outsideLabel={outsideLabel}
                    aria-describedby={showPasswordHints && ariaDescribedById}
                />
                { showPasswordHints && (
                    <React.Fragment>
                        <PasswordHints password={form.get(field)}/>
                        <span id={ariaDescribedById} className="sr-only" aria-hidden="true">
                            {t('customerdetails.password.restrictions')}.
                            {passwordError}
                        </span>
                    </React.Fragment>
                )}

            </div>
        );
    }
}

export default CustomerPassword;
